/**
 * @fileoverview POST handler for the "/channel_dashboard/:app_group_id/:channel_type" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { channelDashboardData } from "./constants";
import type { ChannelDashboardDataParams, ChannelDashboardDataResult } from "./types";

export const getChannelDashboardData = reactQueryFetcherAdapter(
  channelDashboardData,
  (
    signal: AbortSignal,
    {
      appGroupId,
      startDate,
      endDate,
      campaignIds,
      canvasIds,
      platform,
      channelType,
      vertical,
      region,
    }: ChannelDashboardDataParams
  ): Promise<ChannelDashboardDataResult> => {
    return fetch(
      `/channel_dashboard/${appGroupId}/${channelType}`,
      "POST",
      {
        start_date: startDate,
        end_date: endDate,
        campaign_ids: campaignIds,
        canvas_ids: canvasIds,
        platform,
        ...(vertical !== undefined ? { vertical } : {}),
        ...(region !== undefined ? { region } : {}),
      },
      { signal }
    );
  }
);
